import React from 'react';

import CBMediaQuery from '../../shared/CBMediaQuery';

import { formatDate, getStyle, styleMerge } from '../../../utils/utils';
import { translate } from 'react-i18next';
import moment from 'moment';
import CBDisabledBadge from '../../shared/CBDisabledBadge';

class OrganizationListItem extends React.Component {
  render() {
    const {
      organization, onEditClick, t
    } = this.props;

    const { id } = organization;

    const trialIsEnded = organization.is_trialing && moment(organization.trial_end).isBefore(moment(), 'day');
    const isDisabled = !!organization.is_disabled;

    const getCellStyle = (screenSize) => {
      const baseStyle = getStyle(screenSize, styles, 'tableValueText');
      return isDisabled
        ? styleMerge(baseStyle, getStyle(screenSize, styles, 'disabledText'))
        : baseStyle;
    };

    return (
      <CBMediaQuery>
        {screenSize => (
          <tr>
            {
              screenSize === 'large' && (
                <td style={getCellStyle(screenSize)}>{organization.id}</td>
              )
            }
            <td style={getCellStyle(screenSize)}>{organization.name}</td>
            <td style={getCellStyle(screenSize)}>{organization.business_id}</td>
            <td style={getCellStyle(screenSize)}>{organization.is_trialing ? t('yes') : t('no')}{trialIsEnded && ` (${t('isEnded')})`}</td>
            <td style={getCellStyle(screenSize)}>{organization.garages.length}</td>
            <td style={getStyle(screenSize, styles, 'tableValueText')}>
              {isDisabled ? <CBDisabledBadge /> : t('statusActive')}
            </td>
            <td style={getStyle(screenSize, styles, 'tableValueText')}>
              <img
                alt='Options'
                src='/img/icon_edit.svg'
                style={getStyle(screenSize, styles, 'editButton')}
                onClick={() => onEditClick(organization)}
              />
            </td>
          </tr>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    tableValueText: {
      fontFamily: 'TitilliumWeb-Light',
      fontSize: 18,
      color: '#FFFFFF',
    },
    disabledText: {
      opacity: 0.5,
    },
    editButton: {
      cursor: 'pointer',
      width: 20,
      height: 20,
    },
  },
};

export default translate('SettingsView')(OrganizationListItem);
